"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var formik_1 = require("formik");
var react_1 = __importStar(require("react"));
var components_1 = require("../../../../components");
var context_1 = require("../../../../context");
var enums_1 = require("../../../../types/enums");
var utils_1 = require("../../../../utils");
var Checkbox_1 = __importDefault(require("../../../Checkbox"));
var DateInput_1 = __importDefault(require("../../../DateInput"));
var Tabs_1 = require("../../../Tabs/Tabs");
exports.errorKeys = [
    'num_in_household',
    'num_in_household_5',
    'num_in_household_6',
    'num_in_household_12',
    'num_in_household_18',
    'num_in_household_25',
    'num_in_household_35',
    'num_in_household_45',
    'num_in_household_55',
    'num_in_household_65',
    'num_in_household_75',
    'mental_health_issues',
    'autistic_spectrum',
];
var numBoxes = {
    num_in_household_5: 'num-in-household-5',
    num_in_household_6: 'num-in-household-6',
    num_in_household_12: 'num-in-household-12',
    num_in_household_18: 'num-in-household-18',
    num_in_household_25: 'num-in-household-25',
    num_in_household_35: 'num-in-household-35',
    num_in_household_45: 'num-in-household-45',
    num_in_household_55: 'num-in-household-55',
    num_in_household_65: 'num-in-household-65',
    num_in_household_75: 'num-in-household-75',
};
var Resident = function (_a) {
    var tabId = _a.tabId;
    var _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u;
    var _v = context_1.useSemantics(), options = _v.options, trans = _v.trans;
    var setTabError = Tabs_1.useTabsContext().setTabError;
    var _w = formik_1.useFormikContext(), errors = _w.errors, values = _w.values;
    var _x = react_1.useState(((_b = errors.project) === null || _b === void 0 ? void 0 : _b.resident) || {}), formErrors = _x[0], setFormErrors = _x[1];
    react_1.useEffect(function () { return setTabError(tabId, utils_1.objectHasAnyKey(formErrors, exports.errorKeys)); }, [formErrors]);
    react_1.useEffect(function () { var _a; return setFormErrors(((_a = errors.project) === null || _a === void 0 ? void 0 : _a.resident) || {}); }, [(_c = errors.project) === null || _c === void 0 ? void 0 : _c.resident]);
    var value = ((_e = (_d = values.project) === null || _d === void 0 ? void 0 : _d.resident) === null || _e === void 0 ? void 0 : _e.mental_health_issues) || [];
    var mentalHealthIssues = {
        none: 'None',
        prefer_not: 'Prefer not to say',
        depression: 'Depression related',
        anxiety: 'Anxiety related',
        ocd: 'Obsessive compulsive behaviuor related',
        phobia: 'Phobia related',
        panic: 'Panic disorders',
        dementia: 'Dementia related issues',
        other: 'Other',
    };
    return (react_1.default.createElement(components_1.Card, { heading: trans('project:slhh::headings.resident'), subHeading: trans('project:slhh::headings.slhh') },
        react_1.default.createElement(components_1.FormControl, { errors: (_g = (_f = errors.project) === null || _f === void 0 ? void 0 : _f.resident) === null || _g === void 0 ? void 0 : _g.mental_health_issues, label: trans('project:slhh::labels.mental-health-issues') },
            react_1.default.createElement("div", { className: "flex flex-col" }, Object.keys(mentalHealthIssues).map(function (key) { return (react_1.default.createElement(Checkbox_1.default, { key: "mental_health_issues." + key, name: "project.resident.mental_health_issues", label: mentalHealthIssues[key], value: key })); }))),
        (value === null || value === void 0 ? void 0 : value.indexOf(enums_1.BooleanOther.OTHER)) > -1 && (react_1.default.createElement(components_1.FormControl, { errors: (_j = (_h = errors.project) === null || _h === void 0 ? void 0 : _h.resident) === null || _j === void 0 ? void 0 : _j.mental_health_issues_other, label: trans('project:slhh::labels.mental-health-issues-other') },
            react_1.default.createElement(components_1.TextArea, { name: "project.resident.mental_health_issues_other", maxLength: 1500 }))),
        react_1.default.createElement(components_1.FormControl, { errors: (_l = (_k = errors.project) === null || _k === void 0 ? void 0 : _k.resident) === null || _l === void 0 ? void 0 : _l.oldest_dob, label: "Oldest resident's DoB" },
            react_1.default.createElement(DateInput_1.default, { name: "project.resident.oldest_dob" })),
        react_1.default.createElement(components_1.FormControl, { errors: (_o = (_m = errors.project) === null || _m === void 0 ? void 0 : _m.resident) === null || _o === void 0 ? void 0 : _o.autistic_spectrum, label: trans('project:slhh::labels.autistic-spectrum'), showOther: ((_q = (_p = values.project) === null || _p === void 0 ? void 0 : _p.resident) === null || _q === void 0 ? void 0 : _q.autistic_spectrum) === enums_1.BooleanOption.YES, other: react_1.default.createElement(components_1.FormControl, { errors: (_s = (_r = errors.project) === null || _r === void 0 ? void 0 : _r.resident) === null || _s === void 0 ? void 0 : _s.autistic_spectrum_other, label: trans('project:slhh::labels.please-specify') },
                react_1.default.createElement(components_1.TextArea, { fast: true, name: "project.resident.autistic_spectrum_other", maxLength: 5000 })) },
            react_1.default.createElement(components_1.Select, { width: "xs", options: options.booleanOptional(), name: "project.resident.autistic_spectrum" })),
        react_1.default.createElement(components_1.FormControl, { errors: (_u = (_t = errors.project) === null || _t === void 0 ? void 0 : _t.resident) === null || _u === void 0 ? void 0 : _u.num_in_household, label: trans('project:slhh::labels.num-in-household') },
            react_1.default.createElement(components_1.Select, { width: "xs", options: {
                    '1': '1',
                    '2': '2',
                    '3': '3',
                    '4': '4',
                    '5': '5',
                    '6': '6',
                    '7': '7',
                    '8': '8',
                    '9': '9',
                    '10': '10',
                    '11': '11',
                    '12': '12',
                    '13': '13',
                    '14': '14',
                    '15': '15',
                    '16': '16',
                    '17': '17',
                    '18': '18',
                    '19': '19',
                    '20': '20',
                }, name: "project.resident.num_in_household" })),
        Object.keys(numBoxes).map(function (key) {
            var _a, _b;
            return (react_1.default.createElement(components_1.FormControl, { key: "num-" + key, errors: ((_a = errors.project) === null || _a === void 0 ? void 0 : _a.resident) ? (_b = errors.project) === null || _b === void 0 ? void 0 : _b.resident[key] : [], label: trans("project:slhh::labels." + numBoxes[key]) },
                react_1.default.createElement(components_1.Input, { width: "xs", name: "project.resident." + key, type: components_1.InputType.number, step: 1, min: 0, max: 200 })));
        })));
};
exports.default = Resident;
//# sourceMappingURL=ResidentForm.js.map